export const TOGGLE_SIDE_BAR_OPEN = 'TOGGLE_SIDE_BAR_OPEN';

export const FETCH_CURRENT_PATH_NAME = 'FETCH_CURRENT_PATH_NAME';
export const SET_CURRENT_PATH_NAME = 'SET_CURRENT_PATH_NAME';

export const FETCH_SITE_LAYOUT_REQUESTED = 'FETCH_SITE_LAYOUT_REQUESTED';
export const FETCH_SITE_LAYOUT_SUCCEEDED = 'FETCH_SITE_LAYOUT_SUCCEEDED';
export const FETCH_SITE_LAYOUT_FAILED = 'FETCH_SITE_LAYOUT_FAILED';
